import React, { useState } from 'react';
import getFontData from "../../common";
import ChatSidebarModel from './ChatSidebarModel';

const ChatHeader: React.FC = () => {
  const { Contact, Email } = getFontData();
  const [sideBar, setSideBar] = useState<boolean>(false);


  return (
    <div>
      <div className='chat-header'>
        <div className='chat-header-row chat-row-container'>
          <div className='chat-nav'>
            <a href={`mailto:${Email}`} className="chat-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
              </svg>
              {Email}
            </a>
            <a href={`tel:${Contact}`} className="chat-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
              </svg>
              {Contact}
            </a>
            <button type='button' className={sideBar ? "chat-menu-hm chat-menu-hm-active" : "chat-menu-hm"} onClick={() => setSideBar(!sideBar)}>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 14' fill='currentColor' width='16' height='14'>
                <path fillRule='evenodd' clipRule='evenodd' d='M0 7C0 6.44772 0.447715 6 1 6H12C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8H1C0.447715 8 0 7.55228 0 7Z' />
                <path fillRule='evenodd' clipRule='evenodd' d='M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1Z' />
                <path fillRule='evenodd' clipRule='evenodd' d='M0 13C0 12.4477 0.447715 12 1 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H1C0.447715 14 0 13.5523 0 13Z' />
              </svg>
              {sideBar ? <ChatSidebarModel /> : null}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
